import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

const sharedTableList = (props: any) => `
  width: 100%;
  &Actions {
    &Disabled {
      color: ${props.theme.uiColors.interactionDisabled02};
      cursor: default;
      pointer-events: none;
    }
  }
  &Icon {
    font-size: 17px;
  }
  table {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    width: 100%;
    ${mixins.forceScrollbar}
  }
`;

export const EntityListStyle = styled.main`
  display: flex;
  overflow-y: auto;
  width: 100%;

  .campaignPlanList,
  .lineItemsList,
  .insertionOrdersList {
    &__tableList {
      ${props => sharedTableList(props)}
    }
  }

  .campaignPlanList,
  .insertionOrdersList,
  .lineItemsList {
    &__tableList {
      &Actions {
        &AdsButton {
          display: contents;

          i {
            font-size: 0.75rem;
          }
        }
        &ReportingLink {
          color: ${props => props.theme.uiColors.interactionDefault};
          margin-right: var(--spacing-8);

          &Icon{
            font-size: 0.75rem;
          }
        }
      }
    }
  }
`;
